import ApiBase from '../../../api-base'
import { ACTIVE_BASE_REST } from '../../../constants'
export default class FurnitureTrafficPlanTariff extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/tariff/furniture/trafficPlan'
    super(store, path)
  }
}
